import { PAX_TYPE } from 'app/typings/core/admin/enum/paxType';
import { EXPERIENCE_STATUS } from 'app/typings/core/admin/experiences/enum/experienceStatus';
import type { ExperienceResponse } from 'app/typings/core/admin/experiences/experience';

export const DEFAULT_EXPERIENCE_DATA: ExperienceResponse = {
  id: 0,
  categoryId: 0,
  status: EXPERIENCE_STATUS.UNPUBLISHED,
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  spaceIds: [],
  description: undefined,
  hotelId: undefined,
  countryId: undefined,
  coverPictureId: undefined,
  emojiId: undefined,
  openingHours: undefined,
  brand: undefined,
  duration: undefined,
  durationDescription: undefined,
  time: undefined,
  isRoomServiceAvailable: false,
  isRoomServiceIncluded: false,
  roomServicePrice: undefined,
  accessMode: undefined,
  location: undefined,
  closingPeriods: [],
  closedDaysBeforeCheckIn: undefined,
  maxQuantity: undefined,
  availableDayLimits: undefined,
  tagline: undefined,
  minPax: undefined,
  maxPax: undefined,
  isAlwaysIncludedWithNight: false,
  allowedPaxTypes: [PAX_TYPE.ADULT, PAX_TYPE.CHILD],
  deletedAt: undefined,
  coverPicture: undefined,
  emoji: undefined,
  experiencePictures: [],
  openingConfiguration: undefined,
  showInInventory: true,
};
